export default "__VITE_ASSET__BwXtKXcp__"